import React from "react";
import { useNavigate } from "react-router-dom";
import Logo from "../Logo/Logo";
import SigninButton from "./SigninButton/SigninButton";
import MenuCard from "./MenuCard/MenuCard";
import UserProfile from "./UserProfile/UserProfile";
import { useAuthContext } from "@asgardeo/auth-react";

const LogoHeader = ({ showMenu = true }) => {
  const { state } = useAuthContext();
  const navigate = useNavigate();
  return (
    <div className="w-full bg-pl-bg border-b border-pl-border fixed z-[100]">
      <div className="flex items-center justify-between h-16 px-6 md:px-10">
        <button
          onClick={() => navigate("/")}
          className="flex-none items-center gap-20"
        >
          <Logo small />
        </button>
        {showMenu && (
          <div className="flex gap-3 items-center ml-auto md:pb-0 pl-10">
            <MenuCard dropdownClassName="fixed right-6 top-14 md:right-10" />
            {state.isAuthenticated ? <UserProfile /> : <SigninButton />}
          </div>
        )}
      </div>
    </div>
  );
};

export default LogoHeader;
